var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-treeview',{attrs:{"activatable":"","open-on-click":"","return-object":"","transition":"","items":_vm.items,"load-children":_vm.fetchChildren},on:{"update:active":_vm.onChangeActive}})
}
var staticRenderFns = []

export { render, staticRenderFns }